import { History } from "history";

import { PaginateQuery } from "../../interfaces";
import { Paginated } from "../../models";
import {
  CreateMediaError,
  MediaDto,
  UploadAndCreateFlashCardRequest,
  UploadAndCreateFlashCardResponse,
} from "../../interfaces/media";
import { toggleAddEditFlashCardModal } from "./actions";
import {
  CreateFlashCardRequest,
  FlashCardDto,
  UpdateFlashCardRequest,
} from "../../interfaces/flash-card";
import { ToggleLessonStateConsentAction } from "../lesson/actionTypes";
import { CreateMediaProgress } from "../../interfaces/media/create-media-progress.dto";

//#region Get FlashCards

export const GET_FLASH_CARDS = "GET_FLASH_CARDS";
export const GET_FLASH_CARDS_SUCCESS: any = "GET_FLASH_CARDS_SUCCESS";
export const GET_FLASH_CARDS_ERROR: any = "GET_FLASH_CARDS_ERROR";

export interface GetFlashCardsAction {
  type: typeof GET_FLASH_CARDS;
  payload: {
    request: PaginateQuery;
    history: History;
  };
}

export interface GetFlashCardsSuccessAction {
  type: typeof GET_FLASH_CARD_SUCCESS;
  payload: Paginated<FlashCardDto>;
}

export interface GetFlashCardsErrorAction {
  type: typeof GET_FLASH_CARDS_ERROR;
  payload: any;
}
//#endregion

//#region Get FlashCards by Lesson by Lesson Id

export const GET_FLASH_CARDS_BY_LESSON = "GET_FLASH_CARDS_BY_LESSON";
export const GET_FLASH_CARDS_BY_LESSON_SUCCESS: any =
  "GET_FLASH_CARDS_BY_LESSON_SUCCESS";
export const GET_FLASH_CARDS_BY_LESSON_ERROR: any =
  "GET_FLASH_CARDS_BY_LESSON_ERROR";

export interface GetFlashCardsByLessonAction {
  type: typeof GET_FLASH_CARDS_BY_LESSON;
  payload: {
    lessonId: string;
    history: History;
  };
}

export interface GetFlashCardsByLessonSuccessAction {
  type: typeof GET_FLASH_CARDS_BY_LESSON_SUCCESS;
  payload: FlashCardDto[];
}

export interface GetFlashCardsByLessonErrorAction {
  type: typeof GET_FLASH_CARDS_BY_LESSON_ERROR;
  payload: any;
}
//#endregion

//#region Get FlashCard

export const GET_FLASH_CARD = "GET_FLASH_CARD";
export const GET_FLASH_CARD_SUCCESS: any = "GET_FLASH_CARD_SUCCESS";
export const GET_FLASH_CARD_ERROR: any = "GET_FLASH_CARD_ERROR";

export interface GetFlashCardAction {
  type: typeof GET_FLASH_CARD;
  payload: {
    id: string;
    history: History;
  };
}

export interface GetFlashCardSuccessAction {
  type: typeof GET_FLASH_CARD_SUCCESS;
  payload: FlashCardDto;
}

export interface GetFlashCardErrorAction {
  type: typeof GET_FLASH_CARD_ERROR;
  payload: any;
}
//#endregion

//#region Add FlashCard

export const ADD_FLASH_CARD = "ADD_FLASH_CARD";
export const ADD_FLASH_CARD_SUCCESS: any = "ADD_FLASH_CARD_SUCCESS";
export const ADD_FLASH_CARD_ERROR: any = "ADD_FLASH_CARD_ERROR";

export interface AddFlashCardAction {
  type: typeof ADD_FLASH_CARD;
  payload: {
    request: CreateFlashCardRequest;
    history: History;
  };
}

export interface AddFlashCardSuccessAction {
  type: typeof ADD_FLASH_CARD_SUCCESS;
  payload: FlashCardDto;
}

export interface AddFlashCardErrorAction {
  type: typeof ADD_FLASH_CARD_ERROR;
  payload: any;
}
//#endregion

//#region Update FlashCard

export const UPDATE_FLASH_CARD = "UPDATE_FLASH_CARD";
export const UPDATE_FLASH_CARD_SUCCESS: any = "UPDATE_FLASH_CARD_SUCCESS";
export const UPDATE_FLASH_CARD_ERROR: any = "UPDATE_FLASH_CARD_ERROR";

export interface UpdateFlashCardAction {
  type: typeof UPDATE_FLASH_CARD;
  payload: {
    id: string;
    request: UpdateFlashCardRequest;
    history: History;
  };
}

export interface UpdateFlashCardSuccessAction {
  type: typeof UPDATE_FLASH_CARD_SUCCESS;
  payload: FlashCardDto;
}

export interface UpdateFlashCardErrorAction {
  type: typeof UPDATE_FLASH_CARD_ERROR;
  payload: any;
}
//#endregion

//#region Delete FlashCard

export const DELETE_ALL_FLASH_CARD_CONSENT: any =
  "DELETE_ALL_FLASH_CARD_CONSENT";
export const DELETE_ALL_FLASH_CARD = "DELETE_ALL_FLASH_CARD";
export const DELETE_ALL_FLASH_CARD_SUCCESS: any =
  "DELETE_ALL_FLASH_CARD_SUCCESS";
export const DELETE_ALL_FLASH_CARD_ERROR: any = "DELETE_ALL_FLASH_CARD_ERROR";

export interface DeleteAllFlashCardConsentAction {
  type: typeof DELETE_ALL_FLASH_CARD_CONSENT;
  payload: string;
}

export interface DeleteAllFlashCardAction {
  type: typeof DELETE_ALL_FLASH_CARD;
  payload: {
    lessonId: string;
    history: History;
  };
}

export interface DeleteAllFlashCardSuccessAction {
  type: typeof DELETE_ALL_FLASH_CARD_SUCCESS;
  payload: string;
}

export interface DeleteAllFlashCardErrorAction {
  type: typeof DELETE_ALL_FLASH_CARD_ERROR;
  payload: any;
}
//#endregion

//#region Upload FlashCard Image

export const UPLOAD_FLASH_CARD_IMAGE = "UPLOAD_FLASH_CARD_IMAGE";
export const UPLOAD_FLASH_CARD_IMAGE_SUCCESS: any =
  "UPLOAD_FLASH_CARD_IMAGE_SUCCESS";
export const UPLOAD_FLASH_CARD_IMAGE_ERROR: any =
  "UPLOAD_FLASH_CARD_IMAGE_ERROR";

export interface UploadFlashCardImageAction {
  type: typeof UPLOAD_FLASH_CARD_IMAGE;
  payload: {
    file: File;
    history: History;
    flashCardId?: string;
  };
}
export interface UploadFlashCardImageSuccessAction {
  type: typeof UPLOAD_FLASH_CARD_IMAGE_SUCCESS;
  payload: MediaDto;
}

export interface UploadFlashCardImageErrorAction {
  type: typeof UPLOAD_FLASH_CARD_IMAGE_ERROR;
  payload: any;
}
//#endregion

//#region add edit flashCard modal
export const TOGGLE_ADD_EDIT_FLASH_CARD_MODAL: any =
  "TOGGLE_ADD_EDIT_FLASH_CARD_MODAL";

export interface ToggleAddEditFlashCardModalAction {
  type: typeof toggleAddEditFlashCardModal;
  payload: any;
}
//#endregion

//#region Delete All FlashCard

export const DELETE_FLASH_CARD_CONSENT: any = "DELETE_FLASH_CARD_CONSENT";
export const DELETE_FLASH_CARD = "DELETE_FLASH_CARD";
export const DELETE_FLASH_CARD_SUCCESS: any = "DELETE_FLASH_CARD_SUCCESS";
export const DELETE_FLASH_CARD_ERROR: any = "DELETE_FLASH_CARD_ERROR";

export interface DeleteFlashCardConsentAction {
  type: typeof DELETE_FLASH_CARD_CONSENT;
  payload: string;
}

export interface DeleteFlashCardAction {
  type: typeof DELETE_FLASH_CARD;
  payload: {
    id: string;
    history: History;
  };
}

export interface DeleteFlashCardSuccessAction {
  type: typeof DELETE_FLASH_CARD_SUCCESS;
  payload: string;
}

export interface DeleteFlashCardErrorAction {
  type: typeof DELETE_FLASH_CARD_ERROR;
  payload: any;
}
//#endregion

//#region Toggle Flash Card State

export const TOGGLE_FLASH_CARD_STATE_CONSENT: any =
  "TOGGLE_FLASH_CARD_STATE_CONSENT";
export const TOGGLE_FLASH_CARD_STATE = "TOGGLE_FLASH_CARD_STATE";
export const TOGGLE_FLASH_CARD_STATE_SUCCESS: any =
  "TOGGLE_FLASH_CARD_STATE_SUCCESS";
export const TOGGLE_FLASH_CARD_STATE_ERROR: any =
  "TOGGLE_FLASH_CARD_STATE_ERROR";

export interface ToggleFlashCardStateConsentAction {
  type: typeof TOGGLE_FLASH_CARD_STATE_CONSENT;
  payload: string;
}

export interface ToggleFlashCardStateAction {
  type: typeof TOGGLE_FLASH_CARD_STATE;
  payload: {
    id: string;
    history: History;
  };
}

export interface ToggleFlashCardStateSuccessAction {
  type: typeof TOGGLE_FLASH_CARD_STATE_SUCCESS;
  payload: { id: string };
}

export interface ToggleFlashCardStateErrorAction {
  type: typeof TOGGLE_FLASH_CARD_STATE_ERROR;
  payload: any;
}
//#endregion

//#region Upload and Create Flash Card

export const UPLOAD_AND_CREATE_FLASH_CARD = "UPLOAD_AND_CREATE_FLASH_CARD";
export const UPLOAD_AND_CREATE_FLASH_CARD_SUCCESS: any =
  "UPLOAD_AND_CREATE_FLASH_CARD_SUCCESS";
export const UPLOAD_AND_CREATE_FLASH_CARD_ERROR: any =
  "UPLOAD_AND_CREATE_FLASH_CARD_ERROR";
export const UPLOAD_AND_CREATE_FLASH_CARD_PROGRESS: any =
  "UPLOAD_AND_CREATE_FLASH_CARD_PROGRESS";
export const NEW_FLASH_CARD_CREATED: any = "NEW_FLASH_CARD_CREATED";
export const REMOVE_UPLOADED_FLASH_CARD_IMAGE: any =
  "REMOVE_UPLOADED_FLASH_CARD_IMAGE";

export interface UploadAndCreateFlashCardAction {
  type: typeof UPLOAD_AND_CREATE_FLASH_CARD;
  payload: UploadAndCreateFlashCardRequest;
}
export interface UploadAndCreateFlashCardSuccessAction {
  type: typeof UPLOAD_AND_CREATE_FLASH_CARD_SUCCESS;
  payload: UploadAndCreateFlashCardResponse;
}

export interface UploadAndCreateFlashCardErrorAction {
  type: typeof UPLOAD_AND_CREATE_FLASH_CARD_ERROR;
  payload: CreateMediaError;
}

export interface UploadAndCreateFlashCardProgressAction {
  type: typeof UPLOAD_AND_CREATE_FLASH_CARD_PROGRESS;
  payload: CreateMediaProgress;
}

export interface RemoveUploadedFlashCardImageAction {
  type: typeof REMOVE_UPLOADED_FLASH_CARD_IMAGE;
  payload: number;
}

//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetFlashCardsAction
  | GetFlashCardsSuccessAction
  | GetFlashCardsErrorAction
  | GetFlashCardsByLessonAction
  | GetFlashCardsByLessonSuccessAction
  | GetFlashCardsByLessonErrorAction
  | GetFlashCardAction
  | GetFlashCardSuccessAction
  | GetFlashCardErrorAction
  | AddFlashCardAction
  | AddFlashCardSuccessAction
  | AddFlashCardErrorAction
  | UpdateFlashCardAction
  | UpdateFlashCardSuccessAction
  | UpdateFlashCardErrorAction
  | DeleteFlashCardConsentAction
  | DeleteFlashCardAction
  | DeleteFlashCardSuccessAction
  | DeleteFlashCardErrorAction
  | UploadFlashCardImageAction
  | UploadFlashCardImageSuccessAction
  | UploadFlashCardImageErrorAction
  | DeleteAllFlashCardConsentAction
  | DeleteAllFlashCardAction
  | DeleteAllFlashCardSuccessAction
  | DeleteAllFlashCardErrorAction
  | ToggleLessonStateConsentAction
  | ToggleFlashCardStateAction
  | ToggleFlashCardStateSuccessAction
  | ToggleFlashCardStateErrorAction
  | UploadAndCreateFlashCardAction
  | UploadAndCreateFlashCardErrorAction
  | UploadAndCreateFlashCardProgressAction
  | UploadAndCreateFlashCardSuccessAction
  | RemoveUploadedFlashCardImageAction;
